import routes from 'services/RoutesProvider/routes'
import type { InvitationNotification } from 'shared/graphql/graphql'
import type { GetNotificationData } from '../types'

export const getInvitationData = ({ notification, t }: GetNotificationData) => ({
  title: t('notification.new.invitation.title'),
  body: t('notification.new.invitation.body', { tenantName: (notification.data as InvitationNotification).tenantName }),
  route: `${routes.invite}/${notification.invitationCode}`,
})
